import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const DEFAULT_LOCALE = 'zh-Hans'
const LOCALE_STORAGE_KEY = 'jmall_locale'
const languageOptions = [
	{ value: 'zh-Hans', label: '简体中文', description: '简体中文' }, { value: 'zh-Hant', label: '繁體中文', description: '繁体中文' }, { value: 'en', label: 'English', description: '英语' },
	{ value: 'ar', label: 'العربية', description: '阿拉伯语' }, { value: 'bn', label: 'বাংলা', description: '孟加拉语' }, { value: 'de', label: 'Deutsch', description: '德语' },
	{ value: 'es', label: 'Español', description: '西班牙语' }, { value: 'fr', label: 'Français', description: '法语' }, { value: 'hi', label: 'हिन्दी', description: '印地语' },
	{ value: 'id', label: 'Bahasa Indonesia', description: '印度尼西亚语' }, { value: 'ja-JP', label: 'にほんご', description: '日语' }, { value: 'km', label: 'ភាសាខ្មែរ', description: '高棉语' },
	{ value: 'ko', label: '한국어', description: '韩语' }, { value: 'my', label: 'Bahasa Melayu', description: '马来语' }, { value: 'pt', label: 'Português', description: '葡萄牙语' },
	{ value: 'ru', label: 'Русский', description: '俄语' }, { value: 'sk', label: 'Slovenčina', description: '斯洛伐克语' }, { value: 'th', label: 'ไทย', description: '泰语' }, { value: 'vi', label: 'Tiếng Việt', description: '越南语' },
]
const supportedLocales = languageOptions.map(item => item.value)

function getLocale() {
	const urlLocale = new URLSearchParams(window.location.search).get('lang')
	const hashLocale = new URLSearchParams((window.location.hash.split('?')[1] || '')).get('lang')
	const savedLocale = window.localStorage.getItem(LOCALE_STORAGE_KEY)
	const locale = urlLocale || hashLocale || savedLocale || DEFAULT_LOCALE

	return supportedLocales.includes(locale) ? locale : DEFAULT_LOCALE
}

const locale = getLocale()
document.documentElement.lang = locale

// ElementUI 内置文案的语言包名映射（el-pagination、el-table 空态、日期选择器等）。
// 只需列“语言码 ≠ element 包名”或 element 无此语言包的特殊项；同名语言码直接用原值（|| language）。
// element 未提供的语言码（如新增语言）必须在表里显式给出回退，否则 require 不存在的包会直接报错。
const elementLocaleMap = {
	'zh-Hans': 'zh-CN',
	'zh-Hant': 'zh-TW',
	'ja-JP': 'ja',
	ru: 'ru-RU',
	hi: 'en', // element 无印地语包，回退英文
	my: 'en' // element 无缅甸语包，回退英文
}

const messages = supportedLocales.reduce((result, language) => {
	const localeModule = require(`./locale/${language}.json`)
	const appMessages = localeModule.default || localeModule
	const elLang = elementLocaleMap[language] || language
	const elMessages = require(`element-ui/lib/locale/lang/${elLang}.js`).default || {}
	result[language] = Object.assign({}, elMessages, appMessages)
	return result
}, {})

const i18n = new VueI18n({
	locale,
	fallbackLocale: 'zh-Hans',
	messages
})

function setLocale(locale, shouldPersist = false) {
	const nextLocale = supportedLocales.includes(locale) ? locale : DEFAULT_LOCALE
	if (shouldPersist) window.localStorage.setItem(LOCALE_STORAGE_KEY, nextLocale)
	i18n.locale = nextLocale
	document.documentElement.lang = nextLocale
}

export { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, languageOptions, supportedLocales, setLocale }
export default i18n
